function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.222 4.444h-2.489c-.444-.71-.977-1.333-1.6-1.777l1.423-1.423L10.31 0 8.356 1.956a5.246 5.246 0 0 0-1.245-.178c-.444 0-.889.089-1.244.178L3.91 0 2.667 1.244l1.422 1.423c-.622.444-1.156 1.066-1.6 1.777H0v1.778h1.867c-.09.267-.09.622-.09.89V8H0v1.778h1.778v.889c0 .266 0 .622.089.889H0v1.777h2.489C3.378 14.933 5.156 16 7.11 16c1.956 0 3.733-1.067 4.622-2.667h2.49v-1.777h-1.867c.088-.267.088-.623.088-.89v-.888h1.778V8h-1.778v-.889c0-.267 0-.622-.088-.889h1.866V4.444zM8.89 11.556H5.333V9.778H8.89v1.778zM8.89 8H5.333V6.222H8.89V8z"
});

var SvgIconBug = function SvgIconBug(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bug.43ad5dc1.svg";
export { ForwardRef as ReactComponent };